"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _interceptors = require("libs/utils/interceptors");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; } // handles everything related to the logged user.
// logout does a full refresh, as well as navigation to an event,
// so it assumes that once the user is initialized, it does not have to be changed
// user init is exposed through a promise that resolve when the user is loaded, or after successful login
var UserService = /* @ngInject */function UserService(USER_SESSION_ENDPOINT, $rootScope, $q, $http, $injector, $window, accountService) {
  // initial state promise. will resolve on login or initial session check
  var initState = $q.defer();
  var currentEventId = null;
  var getSession = function getSession() {
    return window.BSTG.services.user.getSession();
  };
  var orgIsSuspended = function orgIsSuspended(org) {
    return org.bs_is_blocked === true;
  };
  // if all organization are suspended, the user is in and at least one organization is locked,
  // the backstage is getting locked.
  var isUserAccountSuspended = function isUserAccountSuspended(user) {
    var suspendedOrgsUserIsIn = user.orgs.filter(orgIsSuspended).length;
    var allOrgsUserIsInAreSuspended = suspendedOrgsUserIsIn === user.orgs.length;
    return suspendedOrgsUserIsIn > 0 && allOrgsUserIsInAreSuspended;
  };

  // called after a login or a proper session retriaval to build the user
  // and notify other services depending on the user init state
  var tryFinalizeInit = function tryFinalizeInit() {
    getSession().then(function (_ref) {
      var session = _ref.data;
      // some backward compatibility?
      if (session && session.userCtx) {
        session = session.userCtx;
      }
      if (!session || session.authenticated !== true) {
        throw new Error('invalid session');
      }
      var userAllowedPaths = _.compact(session.bstg_allowed_paths);
      if (session.from_accredited_link && userAllowedPaths && userAllowedPaths.length) {
        $rootScope.userAllowedPaths = session.bstg_allowed_paths;
      }

      // retrieve user and augment it with changes
      return accountService.getUser(session.name, {
        noEvents: true
      }).then(function (_ref2) {
        var userInfo = _ref2.data;
        // we now store a list of the user's most recent changes in the session
        userInfo.changes = session.changes;
        // accreditated links have no names
        if (session.from_accredited_link) {
          userInfo.name = session.name;
        }
        // set the user on our rootScope and resolve the promise
        $rootScope.user = userInfo;
        $rootScope.initUser = true;
        initState.resolve($rootScope.user);
        var isAccountSuspended = isUserAccountSuspended(userInfo);
        if (isAccountSuspended) {
          $rootScope.isAccountSuspended = isAccountSuspended;
        }
        return $rootScope.user;
      });
    }).catch(function (error) {
      $rootScope.initUser = true;
      console.error('Could not initialize user', error.message);
      return initState.reject(error);
    });
    return initState.promise;
  };
  var userService = {
    /**
     * Will try to init the user of not already done.
     * Returns a promise which resolves only when the user is ready.
     * @param {String} eventId
     * @return {Promise}
     */
    init: function init(eventId) {
      if (!currentEventId) {
        currentEventId = eventId;
        tryFinalizeInit();
      }
      return initState.promise;
    },
    /**
     * Check if session is still valid
     * @return {Promise}
     */
    checkSession: function checkSession() {
      return getSession().then(function () {
        return true;
      });
    },
    /**
     * Retrieve the current logged user
     * @return {Object}
     */
    getCurrentUser: function getCurrentUser() {
      return $rootScope.user;
    },
    /**
     * Get current user organizations
     * @return {Promise}
     */
    getCurrentUserOrgs: function getCurrentUserOrgs() {
      var user = userService.getCurrentUser();
      if (!user || user.fp_type === 'accredited_link') {
        return $q.resolve([]);
      }
      return accountService.getUserOrgs(user.name).then(function (_ref3) {
        var data = _ref3.data;
        return data;
      });
    },
    /**
     * Get current user events
     * @return {Promise}
     */
    getUserEvents: function getUserEvents() {
      var user = userService.getCurrentUser();
      if (!user) {
        return $q.resolve([]);
      }
      // shortcut. If the user has no events it will be calling for events anyway.
      if (user.events && user.events.length) {
        return $q.resolve(user.events);
      }
      return accountService.getUser(user.name).then(function (_ref4) {
        var userInfo = _ref4.data;
        var events = $injector.get('eventService').getEventInstancesForUser(userInfo);
        user.events = events;
        return events;
      });
    },
    /**
     * Attempt to log the user with given username/password
     *
     * @param {String} username
     * @param {String} password
     * @param {Object} [accepted_clauses] the user's accepted usage clauses
     *
     * @return {Promise}
     */
    login: function login(username, password, accepted_clauses) {
      var credentials = {};

      // determine the event context we're currently in
      if (currentEventId) {
        // we'll supply it for the session creation routine to consume
        credentials.eid = currentEventId;
      }
      _.extend(credentials, {
        name: username,
        password: password,
        accepted_clauses: accepted_clauses
      });
      return $http.post(USER_SESSION_ENDPOINT, credentials, {
        isSessionCall: true
      }).then(function (_ref5) {
        var data = _ref5.data;
        if (data.warning) {
          $rootScope.setFlashMessage(data.warning, 'warning');
        }
        return tryFinalizeInit();
      });
    },
    /**
     * Logout current user. Will do a full reload if successful
     */
    logout: function logout() {
      return window.BSTG.services.user.logout();
    },
    // PERMISSIONS
    /**
     * Check if current user matches one of the provided conditions (OR), which can be one of those.
     * Several conditions can be put into one to match several conditions at the same time.
     * No condition will return true
     *
     * { userId: id } matches if userId is id
     * { isSpotme: true} matches if user belongs to spotme org
     * { globalRole: role }
     * { eventRole: role, [eventId: eid] } eventId is optional, if not provided, current event is used
     * { eventId: eid } has any role in given event
     * { orgRole: role, orgId: orgId }
     * { orgId: orgId } has any role in given organisation
     *
     * @param {Object} roles
     * @returns {Boolean}
     */
    matchesRoles: function matchesRoles() {
      var _window$BSTG$services;
      // forward to vanilla service
      return (_window$BSTG$services = window.BSTG.services.user).matchesRoles.apply(_window$BSTG$services, arguments);
    },
    /**
     * Determine if the current user has a permission given a context
     * @param  {string}  permissionName name of the permission for which we want to know if the user has access
     * @param  {Object}  context context determining if the user has permission
     * @param  {string}  [context.event_id] context attribute event_id if in the context of an event
     * @param  {string}  [context.org_id] context attribute org_id if in the context of an org
     * @return {Boolean} true if the user has a role enabling the permission and the role is either a global role or
     * every attribute required for the role are both present in the attributed role and the context and are all equal
     * false otherwise
     */
    hasPermission: function hasPermission(permission, context) {
      // forward to vanilla service
      return window.BSTG.services.user.hasPermission(permission, context);
    },
    /**
     * Determine if the current user can attribute assign a different role
     * @param  {Object}  userRoles the supported user roles
     * @param  {Object}  requiredRole the required role
     * @param  {string}  [requiredRole.role] name of the role
     * @param  {string}  [requiredRole.event_id] context attribute event_id if in the context of an event
     * @param  {string}  [requiredRole.org_id] context attribute org_id if in the context of an org
     * @return {Boolean} true if the user has a role enabling the permission and the role is either a global role or
     * every attribute required for the role are both present in the attributed role and the context and are all equal
     * false otherwise
     */
    canAssignRole: function canAssignRole(userRoles, requiredRole) {
      // forward to vanilla service
      return window.BSTG.services.user.canAssignRole(userRoles, requiredRole);
    },
    /**
     * Return full path for users profile in given event
     * @param {String} eventNodeUrl cloud node url
     * @param {String} eventId event ID
     * @param {String} userId user ID
     * @param {Boolean} [isContentHub=false]
     * @returns {String} user'sprofile url
     */
    getProfileUrl: function getProfileUrl(eventNodeUrl, eventId, userId) {
      var isContentHub = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return window.BSTG.services.user.getProfileUrl(eventNodeUrl, eventId, userId, isContentHub);
    },
    /**
     * Checks if the current user can read the organization document
     *
     * @param {String} org_id the organization id
     *
     * @returns {Boolean} if user can read the organization doc
     */
    canReadOrgDoc: function canReadOrgDoc(org_id) {
      return window.BSTG.services.user.canReadOrgDoc(org_id);
    },
    /**
     * Check if a feature is enabled for organisation
     *
     * @param {string} flag the name of the feature to check
     */
    getOrgsByFeatureFlag: function getOrgsByFeatureFlag(flag) {
      return window.BSTG.services.user.getOrgsByFeatureFlag(flag);
    },
    /**
     * Is user event speaker?
     *
     * @param {String} eventId event ID
     * @param {Object} [user=this.user] user object or current user if not provided
     * @returns {Boolean}
     */
    isEventSpeaker: function isEventSpeaker(eventId) {
      var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.user;
      return window.BSTG.services.user.isEventSpeaker(eventId, user);
    },
    /**
     * Is user event moderator?
     *
     * @param {String} eventId event ID
     * @param {Object} [user=this.user] user object or current user if not provided
     * @returns {Boolean}
     */
    isEventModerator: function isEventModerator(eventId) {
      var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.user;
      return window.BSTG.services.user.isEventModerator(eventId, user);
    },
    /**
     * Check if user was invited by link to the event
     *
     * @param {Object} event event object
     * @returns {Boolean}
     */
    isInvitedByLink: function isInvitedByLink(event) {
      return window.BSTG.services.user.isInvitedByLink(event);
    },
    /**
     * Is user a Beta tester
     * @returns {Boolean}
     */
    isBetaTester: function isBetaTester() {
      return window.BSTG.services.user.isBetaTester();
    },
    /**
     * Gets the webapp url for bstg user
     *
     * @param {String} event_id the event id
     * @param {String} redirect the redirect url
     *
     * @returns {String} url
     */
    getWebappLoginUrl: function getWebappLoginUrl(event_id, redirect) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return window.BSTG.services.user.getWebappLoginUrl(event_id, redirect);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * Filter array of items by matching the user roles
     * Array items not defining `roles` property will stay in the result array.
     *
     * @param {Array<Object>} items
     *
     * @returns {Array} items filtered according to roles of current user
     */
    filterByRoles: function filterByRoles(items) {
      return window.BSTG.services.user.filterByRoles(items);
    }
  };
  return userService;
};
UserService.$inject = ["USER_SESSION_ENDPOINT", "$rootScope", "$q", "$http", "$injector", "$window", "accountService"];
UserService.$inject = ["USER_SESSION_ENDPOINT", "$rootScope", "$q", "$http", "$injector", "$window", "accountService"];
angular.module('backstage.services').factory('userService', UserService)
// backward compatibility
.factory('authHelper', UserService)
// add http interceptor if a 401 is catched
.config( /* @ngInject */["$httpProvider", function ($httpProvider) {
  var interceptor = function interceptor() {
    return {
      responseError: function responseError(response) {
        return (0, _interceptors.requestErrorInterceptor)(response);
      }
    };
  };
  $httpProvider.interceptors.push(interceptor);
}]);